import { createSelector, createFeatureSelector } from '@ngrx/store';

import {IDashboardDataState, IDashboardState, IState, StoreFetchState} from '@models/index';
import {StoreModel, StoreModelItem} from '@interfaces/IStoreModel';
import {IGroupDetails} from '@interfaces/IGroupDetails';

export const dashboardSelector = createFeatureSelector<any>('dashboard');
export const getDashboardsSelector = createSelector(dashboardSelector, (state: IDashboardState) => state);
export const getDashboardsLastUpdatesSelector = createSelector(dashboardSelector, (state) => state.data.lastUpdates);
export const getDashboardsGroupDetailSelector = createSelector(dashboardSelector, (state) => state.data.groupDetails || new StoreModelItem());
